import ApiError from '../../../../entities/api-error/ApiError'
import AuthActionTypes from './AuthActionTypes'

export interface RequestLogin {
  type: AuthActionTypes.REQUEST_LOGIN
  payload: {
    email:    string
    password: string
  }
}

export function requestLogin(email: string, password: string): RequestLogin {
  return {
    type: AuthActionTypes.REQUEST_LOGIN,
    payload: {
      email:    email,
      password: password,
    },
  }
}

export interface RequestLoginSuccess {
  type: AuthActionTypes.REQUEST_LOGIN_SUCCESS
  payload: {
    token: string
  }
}

export function requestLoginSuccess(token: string): RequestLoginSuccess {
  return {
    type: AuthActionTypes.REQUEST_LOGIN_SUCCESS,
    payload: {
      token,
    },
  }
}

export interface RequestLoginFailure {
  type: AuthActionTypes.REQUEST_LOGIN_FAILURE
  payload: {
    error: ApiError
  }
}

export function requestLoginFailure(error: ApiError): RequestLoginFailure {
  return {
    type: AuthActionTypes.REQUEST_LOGIN_FAILURE,
    payload: {
      error,
    },
  }
}
